import { Injectable, EventEmitter } from '@angular/core';
import { Account } from '../models/account.model';
import { JwtHelperService } from '@auth0/angular-jwt';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  account$ = new EventEmitter<Account>();

  IsLoading$ = new EventEmitter<boolean>();
  IsHome$ = new EventEmitter<boolean>();
  constructor(private jwtHelper: JwtHelperService) { }

  GetUserData(): Account {

    const token: string | null = localStorage.getItem("token");

    const data = this.jwtHelper.decodeToken(token ? token : '');

    const temp = localStorage.getItem('Usr-Account');

    let account: Account = data;

    if (data) {
      /*
      This is due to UserTypeId could be change while the user is using the system and it is importan to keep it up to date at anytime, anyway there are 
      restrictions on the backend in case of inappropiated use.
      */
      if (temp) {
        let model: Account;
        model = JSON.parse(temp);
        account.userTypeId = model.userTypeId;
      }

      return account;

    } else {
      return account;
    }
  }
}